
import CommonUtils from "@/common-utils";
import axios from "axios";
import { DateTime } from 'luxon';
import { Component, Prop, Vue } from "vue-property-decorator";
import { OrderShipmentTrackingVO } from "./vo/mypage.vo";

@Component
export default class OrderDeliveryTracking extends Vue {
  @Prop() orderCd !: number;
  @Prop() productType !: string;

  noticePop = false; // 배송 상세 도움말

  tracking = {} as OrderShipmentTrackingVO;

  get reverseTracking() {
    if(!this.tracking.trackings || !this.tracking.trackings.length) {
      return [];
    }
    return this.tracking.trackings.reverse();
  }

  // 송장
  searchDelivery(): void {
    // 송장번호가 있을 경우에만 실행(없으면 무반응)
    // TODO window.open으로 했으나 알아보고 변경해야 함
    // 중국
    if( this.tracking.invcNo ) {
      let url = '';
      if(CommonUtils.isSystemLocale('ko')) {
        url = this.tracking.courierUrl + this.tracking.invcNo;
      } else {
        url = this.tracking.courierUrl + this.tracking.invcNo;
      }
      window.open(url);
    }
  } 

  // 택배사별 날짜, 시간 포맷이 다름
  convertDateFormat(date: string) {
    switch(this.tracking.courierCd) {
      case '01': { // CJ
        return DateTime.fromSQL(date).toFormat('yyyy.LL.dd');
      }
      case '02':  // Lotte
        return DateTime.fromFormat(date, 'yyyyLLdd').toFormat('yyyy.LL.dd');
      case '21':  // 글로벌
        return DateTime.fromFormat(date, 'yyyy-LL-dd hh:mm:ss').toFormat('yyyy.LL.dd');
      case '03':
      default:
        return date;
    }
  }

  convertTimeFormat(time: string) {
    switch(this.tracking.courierCd) {
      case '01': { // CJ
        return DateTime.fromSQL(time).toFormat('hh:mm');
      }
      case '02':  // Lotte
        return DateTime.fromFormat(time, 'hhmm').toFormat('hh:mm');
       case '21':  // 글로벌
        return DateTime.fromFormat(time, 'yyyy-LL-dd hh:mm:ss').toFormat('hh:mm');
      case '03':
      default:
        return time;
    }
  }

  created() {
    console.log(this.productType)
    axios.get('mypage/shipping-tracking', {params: {orderCd: this.orderCd, productType: this.productType}}).then(r=>{
      console.log(r.data);
      this.tracking = r.data;
    })
  }
}
